function Footer() {
  return (
    <div class="border w-full">
      <div class=" p-4 w-full lg:flex bg-[#f6900a] mb-4 pb-16">
        <div class="inline-block w-full lg:w-2/3">
          <h2 class="uppercase  text-gray-100 text-lg font-bold">
            SIGN up to newslettter and recieve coupon for first shopping{' '}
          </h2>
        </div>
        <div class="lg:w-3/4">
          <input class="border rounded-full float-right p-2 w-full" placeholder="Your email"></input>
        </div>
      </div>
      <div class="grid p-2 lg:grid-cols-5">
        <div class="">
          <h2 class="text-xl text-red-600 font-bold">SHOPS GHANA</h2>
          <h4 class="text-sm text-gray-600">
            {' '}
            Your one stop shop for all major equipments
          </h4>
        </div>
        <div class="text-gray-600">
          <h2 class="font-bold">MY ACCOUNT</h2>
          <ul>
            <li class="p-2">About Us</li>
            <li class="p-2">Stores</li>
            <li class="p-2">Privacy Policy</li>
            <li class="p-2">My Account</li>
            <li class="p-2">Testimonials</li>
          </ul>
        </div>
        <div class="text-gray-600">
          <h2 class="font-bold">CUSTOMER SERVICE</h2>
          <ul>
            <li class="p-2">My Account</li>
            <li class="p-2">Order History</li>
            <li class="p-2">Guides</li>
            <li class="p-2">Newletter Subs</li>
            <li class="p-2">Contact Us</li>
          </ul>
        </div>
        <div class="text-gray-600">
          <h2 class="font-bold">PAYMENT & SHIPPING</h2>
          <ul>
            <li class="p-2">Terms Of Use</li>
            <li class="p-2">Payment Methods</li>
            <li class="p-2">Return Policy</li>
            <li class="p-2">Shipping Guides</li>
            <li class="p-2">Your Account</li>
          </ul>
        </div>
        <div class="text-gray-600">
          <h2 class="font-bold">LEGAL</h2>
          <ul>
            <li class="p-2">Claim</li>
            <li class="p-2">Privacy</li>
            <li class="p-2">Policy</li>
            <li class="p-2">Terms</li>
          </ul>
        </div>
      </div>
      <div class="p-4 bottom-0 border-t mt-4 text-gray-700">
        <h4 class="">Copyright 2022 shopsghana. All rights reserved</h4>
      </div>
    </div>
  );
}

export default Footer;
